// removed by extract-text-webpack-plugin
module.exports = {"root":"root__1GCIF"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.css
// module id = 409
// module chunks = 3